export default {
  widget: {
    issuer: "https://prestigepeo.okta.com/oauth2/default",
    clientId: "#{clientId}",
    redirectUri: `${window.location.origin}/login/callback`,
    scopes: ["openid", "profile", "email"],
    logo: "Logo_white.svg",
  },
};
